/**
 * Copyright ©2023 Drivepoint
 */

import React, {createRef, useImperativeHandle, useRef} from "react";
import StandardMenu, {StandardMenuInterface, StandardMenuItem} from "../StandardMenu/StandardMenu";
import WebAppServerClient from "../../services/clients/WebAppServerClient";
import Logger from "../../utilities/logger/Logger";
import useStateChange from "../../hooks/useStateChange";
import BainbridgeUser from "../../services/user/BainbridgeUser";

const logger = Logger.logger;

export type NavigationPageItemMenuProps = {
  inNav?: boolean;
  onPageEdit?: (page: any) => void;
};

export type NavigationPageItemMenuInterface = {
} & StandardMenuInterface;

const NavigationPageItemMenu = React.forwardRef<NavigationPageItemMenuInterface, NavigationPageItemMenuProps>((props: NavigationPageItemMenuProps, ref: any): any => {

  useImperativeHandle(ref, (): NavigationPageItemMenuInterface => ({
    open: (element: HTMLElement, data?: any): void => {
      if (props.inNav && !data?.favorite) { return; }
      menu.current?.open(element, data);
    },
    close: () => close()
  }));

  const menu = createRef<StandardMenuInterface>();
  const pageEditDialog = useRef<any>();

  const actionsMenuItems: StandardMenuItem[] = [
    {id: "favorite", label: "${data?.favorite ? 'Remove Favorite' : 'Add Favorite'}"},
    {id: "edit", label: "Edit", visible: "${!!data?.custom}"}
  ];

  const company = useStateChange<any>("company");
  const user = useStateChange<BainbridgeUser>("user");

  async function toggleFavorite(data: any): Promise<void> {
    if (!user || !company) { return; }
    WebAppServerClient.request(`/api/company/${company.id}/user/${user.user.email}/favorite/${data.id}/toggle`, "PATCH");
  }

  async function edit(page: any): Promise<void> {
    if (props.onPageEdit) { props.onPageEdit(page); }
  }

  async function onActionsMenuItemClick(item: StandardMenuItem, data?: any): Promise<void> {
    if (!data) { return; }
    switch (item.id) {
      case "favorite":
        toggleFavorite(data);
        break;
      case "edit":
        edit(data);
        break;
    }
  }

  return <StandardMenu items={actionsMenuItems} onClick={onActionsMenuItemClick} ref={menu} />;

});

export default NavigationPageItemMenu;
